export const enum DocumentExtensionTypeEnum {
  PDF = "1",
  DOCUMENT = "2",
  IMAGES = "3",
}
